export type GetPlansParamsType = {
  page?: string;
  itemsPerPage?: string;
  search?: string;
};

/** Load full plan catalog for filters/dropdowns (not paginated table views). */
export const ALL_PLANS_QUERY_PARAMS: GetPlansParamsType = {
  page: '1',
  itemsPerPage: '500',
};

export type GetUserParamsType = {
  type?: string;
  status?: string;
  productIds?: string[];

  orderBy?: string;

  page?: string;
  itemsPerPage?: string;

  search?: string;
};
